import { useLocale } from '@dreamstack/i18n'
import { MyAccentroBaseUrls } from './getMyAccentroUrl'

export const useMyAccentroBaseUrl = () => {
  const locale = useLocale()
  return MyAccentroBaseUrls[locale]
}
